import {
  AddressRequestBodyV2,
  EmailData,
  IdentityCardRequestBody,
  PersonData,
} from '@dms/api/customer';
import {BusinessInfoData} from '@dms/api/shared';

/* eslint-disable eag/match-named-export */

export const emptyEmail: EmailData = {
  email: '',
  type: null,
};

export const emptyIdentityCard: IdentityCardRequestBody = {
  id: null,
  cardData: {
    type: null,
    cardNumber: '',
    issuedOn: null,
    validUntil: null,
    issuer: null,
    issuedInCountryCode: null,
    note: null,
  },
};

export const emptyPersonData: PersonData = {
  firstName: null,
  lastName: null,
  middleName: null,
  titleBefore: null,
  titleAfter: null,
  genderKey: null,
  roles: null,
  roleType: null,
  citizenshipCode: null,
  birthdate: null,
  personalIdentifier: null,
  preferredLanguage: null,
};

export const emptyBusinessInfoData: BusinessInfoData = {
  countryOfRegistrationCode: null,
  registrationNumber: null,
  vatNumber: null,
  tradeName: null,
  fileNumber: null,
};

export const emptyAddressSvk = {
  address: {
    prefix: '',
    street: '',
    descriptiveNumber: null,
    orientationNumber: null,
    city: '',
    zip: '',
    country: '',
    addressComplement: '',
    coordinates: null,
    postal: null,
  },
  type: '',
};

export const emptyAddressCze = {
  address: {
    prefix: '',
    street: '',
    descriptiveNumber: null,
    orientationNumber: null,
    city: '',
    zip: '',
    country: '',
    addressComplement: '',
    coordinates: null,
    postal: null,
  },
  type: '',
};

export const emptyAddressPol: AddressRequestBodyV2 = {
  address: {
    prefix: '',
    street: '',
    descriptiveNumber: null,
    orientationNumber: null,
    city: '',
    zip: '',
    country: '',
    addressComplement: '',
    coordinates: null,
    postal: null,
  },
  type: '',
  invalid: null,
};
